export default "__VITE_ASSET__BasLVVkr__"